import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    personalId: 0,

    personalDatos: [],
    /* Guardamos el nombre completo del personal */
    personalNombre: '',
    personalHijos: [],
    personalDiasVacaciones: [],
    personalHerramientas: [],
    inactivo: false,

    personalNovedades: [],
    paginaActualNovedades: 1,
    registrosPorPaginaNovedades: 10,
    totalRegistrosNovedades: 0,
    totalPaginasNovedades: 0,

    personalBienes: []
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS' (state, personalId) {
        state.personalId = personalId;
        state.personalDatos = [];
        state.personalHijos = [];
        state.inactivo = false;
        state.personalDiasVacaciones = [];
        state.personalHerramientas = [];
        state.personalNovedades = [];
        state.paginaActualNovedades = 1;
        state.personalBienes = [];
    },
    'SET_PERSONAL_DATOS' (state, params) {
        state.personalDatos = params.personalDatos;
        state.personalNombre = params.personalNombre;
        state.inactivo = params.inactivo;
        state.personalHijos = params.hijos;
        state.personalDiasVacaciones = params.diasVacaciones;
        state.personalHerramientas = params.herramientas;
        state.personalBienes = params.bienes;
    },
    'SET_PERSONAL_NOVEDADES' (state, params) {
        state.personalNovedades = params.personalNovedades;
    },
    'SET_PAGINATION_NOVEDADES' (state, params) {
        state.paginaActualNovedades = params.paginaActual;
        state.totalPaginasNovedades = params.totalPaginas;
        state.registrosPorPaginaNovedades = params.registrosPorPagina;
        state.totalRegistrosNovedades = params.totalRegistros;
    },
    'REMOVE_BIEN' (state, bienId) {
        let itemKey = state.personalBienes
            .findIndex(bien => bien.id == bienId);

        if (itemKey != -1) {
            state.personalBienes.splice(itemKey, 1);
        }
    },
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, personalId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR_DATOS', personalId);

            apiAxios.get(`personal/${personalId}`) 
                .then(res => {
                    /*var legajo = res.data.cargos;*/
                    let personalNombre= res.data.apellido.trim() + ' ' + res.data.nombre.trim();

                    let datos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'apellido', 'campo': 'Apellido', 'valor': res.data.apellido, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'direccion', 'campo': 'Direccion', 'valor': res.data.direccion, 'formato': '' },
                        { 'nombre': 'codigoPostal', 'campo': 'Cod.Postal', 'valor': res.data.codigoPostal, 'formato': '' },
                        { 'nombre': 'localidad', 'campo': 'Localidad', 'valor': res.data.localidad, 'formato': '' },
                        { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                        { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                        { 'nombre': 'celular', 'campo': 'Celular', 'valor': res.data.celular, 'formato': '' },
                        { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        { 'nombre': 'documentoTipo', 'campo': 'Tipo Doc.', 'valor': res.data.documentoTipo, 'formato': '' },
                        { 'nombre': 'documentoNumero', 'campo': 'Nro. Doc.', 'valor': res.data.documentoNumero, 'formato': '' },
                        { 'nombre': 'fechaNacimiento', 'campo': 'Fecha de Nacimiento', 'valor': res.data.fechaNacimiento, 'formato': 'fecha' },
                        { 'nombre': 'estadoCivil', 'campo': 'Estado Civil', 'valor': res.data.estadoCivil, 'formato': '' },
                        { 'nombre': 'condicionFiscal', 'campo': 'Condición Fiscal', 'valor': res.data.condicionFiscal, 'formato': '' },
                        { 'nombre': 'tipoIdentificacionTributaria', 'campo': 'Tipo Identificacion Tributaria', 'valor': res.data.tipoIdentificacionTributaria, 'formato': 'cuit' },
                        { 'nombre': 'codigoIdentificacionTributaria', 'campo': 'Cod. Identificación Tributaria', 'valor': res.data.codigoIdentificacionTributaria, 'formato': 'cuit' },
                        // { 'nombre': 'cuit', 'campo': 'CUIT', 'valor': res.data.cuit, 'formato': 'cuit' },
                        { 'nombre': 'matricula', 'campo': 'Matricula', 'valor': res.data.matricula, 'formato': '' },
                        { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                        { 'nombre': 'numeroCuenta', 'campo': 'Nro. Cuenta', 'valor': res.data.numeroCuenta, 'formato': '' },
                        { 'nombre': 'cbu', 'campo': 'CBU', 'valor': res.data.cbu, 'formato': '' },
                        { 'nombre': 'cbuAlias', 'campo': 'CBU Alias', 'valor': res.data.cbuAlias, 'formato': '' },
                        { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        { 'nombre': 'fechaIngreso', 'campo': 'Fecha Ingreso', 'valor': res.data.fechaIngreso, 'formato': 'fecha' },
                        { 'nombre': 'fechaEgreso', 'campo': 'Fecha Egreso', 'valor': res.data.fechaEgreso, 'formato': 'fecha' },

                        { 'nombre': 'celularTrabajo', 'campo': 'Telefono Laboral', 'valor': res.data.celularTrabajo, 'formato': '' },
                        { 'nombre': 'emailTrabajo', 'campo': 'Email Laboral', 'valor': res.data.emailTrabajo, 'formato': '' },

                        { 'nombre': 'contacto', 'campo': 'Contacto', 'valor': res.data.contacto, 'formato': '' },
                        { 'nombre': 'telefonoContacto', 'campo': 'Telefono Contacto', 'valor': res.data.telefonoContacto, 'formato': '' },

                        { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },

                        { 'nombre': 'cargo', 'campo': 'Cargo', 'valor': res.data.cargo, 'formato': '' },
                        { 'nombre': 'externo', 'campo': 'Asesor Externo', 'valor': res.data.externo? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'socio', 'campo': 'Socio', 'valor': res.data.socio? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'facturaHonorarios', 'campo': 'Factura Honorarios', 'valor': res.data.facturaHonorarios? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    if ((/true/i).test(res.data.facturaHonorarios)) {
                        datos.push({ 'nombre': 'proveedor', 'campo': 'Proveedor', 'valor': res.data.proveedor, 'formato': '' });
                    }

                    // let herramientas = [
                    //     { 'nombre': 'computadora', 'campo': 'Computadora', 'valor': res.data.computadora ? 'Si' : 'No', 'formato': '' }
                    // ];
                    // if ((/true/i).test(res.data.computadora)) {
                    //     herramientas.push({ 'nombre': 'computadoraMarca', 'campo': 'Computadora - Marca', 'valor': res.data.computadoraMarca, 'formato': '' });
                    //     herramientas.push({ 'nombre': 'computadoraNumeroSerie', 'campo': 'Computadora - Nro Serie', 'valor': res.data.computadoraNumeroSerie, 'formato': '' });
                    // }
                    // herramientas.push({ 'nombre': 'telefono', 'campo': 'Celular', 'valor': res.data.telefono ? 'Si' : 'No', 'formato': '' });
                    // if ((/true/i).test(res.data.telefono)) {
                    //     herramientas.push({ 'nombre': 'telefonoMarca', 'campo': 'Celular - Marca', 'valor': res.data.telefonoMarca, 'formato': '' });
                    //     herramientas.push({ 'nombre': 'telefonoIMEI', 'campo': 'Celular - IMEI', 'valor': res.data.telefonoIMEI, 'formato': '' });
                    //     herramientas.push({ 'nombre': 'telefonoNumero', 'campo': 'Celular - Número', 'valor': res.data.telefonoNumero, 'formato': '' });
                    // }
                    // herramientas.push({ 'nombre': 'silla', 'campo': 'Silla', 'valor': res.data.silla ? 'Si' : 'No', 'formato': '' });
                    // herramientas.push({ 'nombre': 'mouse', 'campo': 'Mouse', 'valor': res.data.mouse ? 'Si' : 'No', 'formato': '' });
                    // herramientas.push({ 'nombre': 'headset', 'campo': 'Headset', 'valor': res.data.headset ? 'Si' : 'No', 'formato': '' });

                    let herramientas = [
                        { 'nombre': 'silla', 'campo': 'Silla', 'valor': res.data.silla ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'mouse', 'campo': 'Mouse', 'valor': res.data.mouse ? 'Si' : 'No', 'formato': '' },
                        { 'nombre': 'headset', 'campo': 'Headset', 'valor': res.data.headset ? 'Si' : 'No', 'formato': '' }
                    ];

                    let params = {
                        personalDatos: datos,
                        inactivo: moment(res.data.fechaEgreso).format('YYYY-MM-DD') != '1900-01-01',
                        hijos: res.data.hijos,
                        diasVacaciones: res.data.diasVacaciones,
                        // personalContactoDatos: datosContactos,
                        // personalLaboralDatos: datosLaboral,
                        personalNombre: personalNombre,
                        herramientas,
                        bienes: res.data.bienes
                    }

                    commit('SET_PERSONAL_DATOS', params);
                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    getNovedades ( { commit, state } ) {
        return new Promise((resolve, reject) => { 

            let queryString = '?'
                + 'pageSize=' + state.registrosPorPaginaLegajo
                + '&pageNumber=' + state.paginaActualLegajo;

            apiAxios.get(`personal/${state.personalId}/novedades` + queryString) 
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params= {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages
                        }
                        commit ('SET_PAGINATION_NOVEDADES', params);
                    }
    
                    let params = {
                        personalNovedades: res.data
                    }

                    commit('SET_PERSONAL_NOVEDADES', params);
                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
    removeBien( { commit }, bienId) {
        return new Promise((resolve, reject) => {
            commit('REMOVE_BIEN', bienId);
            resolve();
        })
    }    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}